import React from "react";
import { Assets_URL } from "../../Apicongfig";

function DiscussionParticipant({ selectedMoment }) {
  if (!selectedMoment?.user_with_participants?.length) {
    return <div>No participants found</div>;
  }

  // Get unique participants by email (or another unique field)
  const uniqueParticipants = selectedMoment.user_with_participants.reduce(
    (acc, current) => {
      // Check if we already have a participant with this email
      const exists = acc.find(
        (participant) => participant.email === current.email
      );
      if (!exists) {
        return acc.concat([current]);
      }
      return acc;
    },
    []
  );

  return (
    <div className="card rounded-0 h-100">
      <div className="card-header bg-transparent">
        <h5>Participants</h5>
      </div>
      <div className="card-body chat-cardbody pe-0">
        {uniqueParticipants?.map((participant) => (
          <div key={participant.id} className="d-flex gap-2 align-items-center mb-3 mt-4">
            <div>
              <img
                src={
                  participant.participant_image?.startsWith("http")
                    ? participant.participant_image
                    : Assets_URL + "/" + participant.participant_image
                }
                width={48}
                height={48}
                className="rounded-circle object-fit-cover"
                style={{ objectPosition: "top" }}
                alt="avatar"
              />
            </div>
            <div>
              <h6 className="m-0">{participant?.full_name}</h6>
              <p className="m-0 text-muted">
                {participant?.post}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default DiscussionParticipant;